import { createContext } from 'react';

import { PaymentType } from '@/config/constant';

export interface PaymentChannelInfo {
  paymentType: PaymentType; // 渠道
  income: number; // 收入
  refund: number; // 退款
}

export interface BillIncomeInfo {
  projectCode: string; // 类名
  income: number; // 收入
}

export interface HandoverInfo {
  id: number; // 交班id
  employeeNo: string; // 工号
  employeeName: string; // 名称
  startTime: number; // 班次开始时间
  endTime?: number; // 班次结束时间
  lastPettyCash: number; // 上班备用金
  nextPettyCash: number; // 下班备用金
  handInPettyCash: number; // 本班上交现金
  shiftHandoverVOList: PaymentChannelInfo[];
  shiftText?: string; // 交班须知
}

export const DrawerContext = createContext({
  setLoadingStatus: (status: boolean) => {},
  getHandoverInfo: () => {},
  handoverId: null,
});

// 枚举值渲染
export const createMapRender = (enumMap: Object, defaultVal?) => (val) =>
  enumMap[val] || defaultVal;
